import React from 'react';
import {Modal, Button, Typography, Space, Divider} from 'antd';
import {CopyOutlined, CheckCircleOutlined, CloseCircleOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';

const {Title, Text} = Typography;

interface AddToPodReviewModalProps {
    visible: boolean;
    onClose: () => void;
    result: {
        success: boolean;
        markedCount: number;
        failedCount: number;
        failedTrackingNumbers: string[];
    } | null;
}

const AddToPodReviewModal: React.FC<AddToPodReviewModalProps> = ({
                                                                     visible,
                                                                     onClose,
                                                                     result
                                                                 }) => {
    const {t} = useTranslation();

    const handleCopyTrackingNumbers = () => {
        if (result?.failedTrackingNumbers && result.failedTrackingNumbers.length > 0) {
            const trackingNumbersText = result.failedTrackingNumbers.join(', ');
            navigator.clipboard.writeText(trackingNumbersText).then(() => {
                // 可以添加复制成功的提示
            }).catch(() => {
                // 可以添加复制失败的提示
            });
        }
    };

    if (!result) {
        return null;
    }

    return (
        <Modal
            title={
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <div
                        style={{
                            width: 4,
                            height: 20,
                            backgroundColor: '#722ed1',
                            marginRight: 12,
                            borderRadius: 2
                        }}
                    />
                    <span style={{fontWeight: 'bold'}}>
                        {t('podReview.addToPodReview.title')}
                    </span>
                </div>
            }
            open={visible}
            onCancel={onClose}
            footer={[
                <Button
                    key="ok"
                    type="primary"
                    onClick={onClose}
                    style={{
                        backgroundColor: '#722ed1',
                        borderColor: '#722ed1',
                        borderRadius: 6
                    }}
                >
                    {t('components.button.ok')}
                </Button>
            ]}
            width={500}
            centered
            closable
        >
            <div style={{padding: '16px 0'}}>
                {/* 成功和失败统计 */}
                <Space direction="vertical" size={8} style={{width: '100%'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <CheckCircleOutlined style={{color: '#52c41a', marginRight: 8}}/>
                        <Text strong>
                            {t('podReview.addToPodReview.succeeded')}: {result.markedCount}
                        </Text>
                    </div>

                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <CloseCircleOutlined style={{color: '#ff4d4f', marginRight: 8}}/>
                        <Text strong>
                            {t('podReview.addToPodReview.failed')}: {result.failedCount}
                        </Text>
                    </div>
                </Space>

                {/* 失败原因 */}
                {result.failedCount > 0 && (
                    <>
                        <div style={{marginTop: 16, marginBottom: 8}}>
                            <Text type="secondary">
                                {t('podReview.addToPodReview.failureReason')}
                            </Text>
                        </div>

                        {/* 失败的追踪号列表 */}
                        <div
                            style={{
                                backgroundColor: '#f5f5f5',
                                border: '1px solid #d9d9d9',
                                borderRadius: 6,
                                padding: 12,
                                marginTop: 8
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: 8
                                }}
                            >
                                <Text strong>{t('podReview.addToPodReview.trackingNumber')}</Text>
                                <Button
                                    type="text"
                                    size="small"
                                    icon={<CopyOutlined/>}
                                    onClick={handleCopyTrackingNumbers}
                                    style={{color: '#666'}}
                                />
                            </div>

                            <div style={{wordBreak: 'break-all'}}>
                                <Text>{result.failedTrackingNumbers.join(', ')}</Text>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default AddToPodReviewModal;
